import { Only } from '../Only.js';
import { isYoutube, isVimeo } from './linkUtils.js';
import { PlayerFrameWithIFrame } from './PlayerFrameWithIFrame.js';
import { PlayerFrameWithVimeoApi } from './PlayerFrameWithVimeoApi.js';
import { PlayerFrameWithYoutubeApi } from './PlayerFrameWithYoutubeApi.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function PlayerFrame({
  mediaUrl,
  autoplay
}) {
  const srcHasQueryParams = mediaUrl.includes('?');
  const videoUrl = `${mediaUrl}${srcHasQueryParams ? '&' : '?'}autoplay=1&modestbranding=1`;
  if (isYoutube(mediaUrl)) return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Only, {
      on: ['phone', 'tablet'],
      children: /*#__PURE__*/jsx(PlayerFrameWithYoutubeApi, {
        src: videoUrl
      })
    }), /*#__PURE__*/jsx(Only, {
      on: "desktop",
      children: /*#__PURE__*/jsx(PlayerFrameWithIFrame, {
        src: `${videoUrl}${autoplay ? '&mute=1' : ''}`
      })
    })]
  });
  if (isVimeo(mediaUrl)) return /*#__PURE__*/jsx(PlayerFrameWithVimeoApi, {
    src: mediaUrl
  });
  return /*#__PURE__*/jsx(PlayerFrameWithIFrame, {
    src: `${videoUrl}${autoplay ? '&mute=1' : ''}`
  });
}
export { PlayerFrame };
//# sourceMappingURL=PlayerFrame.js.map
